export default {
  data() {
    return {
      sendCodeSecond: 12,
      isReadNotes: false,
      signupNoticeId: this.$route.query.signupNoticeId,
      signupData: null
    };
  },
  created() {
    if(!this.signupNoticeId){
      this.$router.push("/index");
    } else {
      this.getNewNoticeById();
    }
  },
  methods: {
    async onClickGoLogin() {
      sessionStorage.removeItem("signupMobileForm");
      let {signupNoticeId} = this;
      this.$router.push({
        path: 'bm_login',
        query: {signupNoticeId}
      });
    },
    async getNewNoticeById() {
      // 根据报名通知ID查询报名须知 #李茹钰/2019-03-14#
      this.$message.loading();
      let {data} = await this.$ajax.gateway("/bm-kids/ISignupNoticeApi_getNoticeProtocol_1", {
        signupNoticeId: this.signupNoticeId
      });
      if(data.code === 200 && typeof data.data === "object"){
        this.$message.hide();
        data = data.data;
        this.signupData = data;
        this.sendCodeSecond = data.waitTime;
        this.isReadNotes = true;
        this.startReadNotesTime();
      } else {
        this.$router.push("/index");
      }
    },
    startReadNotesTime() {
      if (this.sendCodeSecond === 0) {
        this.isReadNotes = false;
        this.sendCodeSecond = 14;
        return false;
      } else {
        this.sendCodeSecond--;
        setTimeout(() => {
          this.startReadNotesTime();
        }, 1000);
      }
    }
  }
};
